import * as z from "zod/v4";

const LocationInventoryEntrySchema = z.object({
  available: z.number(),
  inventoryTracked: z.boolean(),
});

export const getLocationFilteredInventory = {
  name: "getLocationFilteredInventory" as const,
  input: z.object({
    draftReturnId: z.string(),
    variantExternalIds: z.array(z.string()),
  }),
  output: z
    .object({ inventory: z.record(z.string(), LocationInventoryEntrySchema) })
    .nullable(),
};
